/**
 * Print a PDF blob without window.open — avoids pop-up blockers after async
 * generation (see ipd-billing PdfPreviewModal.js).
 */
export function printPdfBlob(blob) {
  return new Promise((resolve, reject) => {
    if (!blob) {
      reject(new Error("Missing PDF blob"));
      return;
    }

    const url = URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    // Chrome's PDF viewer does not render into a 0x0 frame, so print() had
    // nothing to print. Keep it real-sized but invisible.
    iframe.style.cssText =
      "position:fixed;right:0;bottom:0;width:1px;height:1px;border:none;opacity:0;pointer-events:none;";
    iframe.title = "Print";

    let settled = false;
    const finish = (err) => {
      if (settled) return;
      settled = true;
      setTimeout(() => {
        URL.revokeObjectURL(url);
        iframe.remove();
      }, 60000);
      if (err) reject(err);
      else resolve();
    };

    let printed = false;
    const runPrint = () => {
      if (printed) return;
      printed = true;
      try {
        const win = iframe.contentWindow;
        if (!win) throw new Error("Print frame unavailable");
        win.focus();
        win.print();
        finish();
      } catch (err) {
        finish(err);
      }
    };

    // Give the PDF viewer a moment to lay out after load before printing.
    iframe.onload = () => setTimeout(runPrint, 300);
    iframe.onerror = () => finish(new Error("Failed to load PDF for printing"));

    document.body.appendChild(iframe);
    iframe.src = url;

    // Some browsers load PDF plugins without firing onload reliably. This used
    // to fire at 500ms, which printed the frame before the PDF had loaded.
    setTimeout(() => {
      if (!settled) runPrint();
    }, 3000);
  });
}
